var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EmptyValidation } from "@domains/utils/commonText";
import { ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { FieldNames } from "@frameworks/pmsjourney/constants/constant";
var AifPmsPresenter = /** @class */ (function () {
    function AifPmsPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    AifPmsPresenter.prototype.downloadProductFile = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.downloadProductFile.execute({
                onSuccess: function (data) {
                    // this.actions.aifPmsActions.downloadProductFile(data);
                    resolve(data);
                },
                onError: function (error) {
                    console.log(error, "Response error");
                    reject(error);
                },
            }, req);
        });
    };
    AifPmsPresenter.prototype.updateClientDetails = function (req) {
        this.actions.aifPmsActions.updateClientDetails(req);
    };
    AifPmsPresenter.prototype.getFilterDetails = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.filterDetails.execute({
                onSuccess: function (data) {
                    switch (requestPayload.fieldName) {
                        case FieldNames.AMCNAME:
                            _this.actions.aifPmsActions.getFilterDetailsAmc(data.data);
                            break;
                        case FieldNames.FUNDMANAGER:
                            _this.actions.aifPmsActions.getFilterDetailsFund(data.data);
                            break;
                        case FieldNames.CATEGORY:
                            _this.actions.aifPmsActions.getFilterDetailsCategory(data.data);
                            break;
                        case FieldNames.FUND_NAME:
                            _this.actions.aifPmsActions.getFilterDetailFundName(data.data);
                            switch (requestPayload.category_code) {
                                case ESubProductIds.AIF:
                                    _this.actions.aifPmsActions.getFilterListAIFFundName(data.data);
                                    break;
                                default:
                                    _this.actions.aifPmsActions.getFilterListFundName(data.data);
                                    break;
                            }
                            break;
                        default:
                    }
                    if (data) {
                        _this.actions.aifPmsActions.updateMsg({
                            msg: EmptyValidation.default,
                            show: true,
                            icon: "",
                        });
                    }
                    resolve(data.data);
                    _this.actions.aifPmsActions.stopAifPmsLoader();
                },
                onError: function (error) {
                    _this.actions.aifPmsActions.setError({
                        isOpen: true,
                        error: error,
                    });
                    _this.actions.aifPmsActions.stopAifPmsLoader();
                    reject(error);
                },
            }, requestPayload);
        });
    };
    AifPmsPresenter.prototype.getProductDetails = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.productDetails.execute({
                onSuccess: function (data) {
                    _this.actions.aifPmsActions.getProductDetails(data.data);
                    if (data) {
                        _this.actions.aifPmsActions.updateMsg({
                            msg: EmptyValidation.default,
                            show: true,
                            icon: "",
                        });
                    }
                    resolve(data);
                    _this.actions.aifPmsActions.stopAifPmsLoader();
                },
                onError: function (error) {
                    reject(error);
                    _this.actions.aifPmsActions.setError({
                        isOpen: true,
                        error: error,
                    });
                    _this.actions.aifPmsActions.stopAifPmsLoader();
                },
            }, requestPayload);
        });
    };
    AifPmsPresenter.prototype.getAifPmsWatchList = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.actions.aifPmsActions.setError({
                isOpen: false,
                error: undefined,
            });
            var _request = __assign({}, requestPayload);
            _request.returnExpectation = _request.return_Expectations;
            delete _request.return_Expectations;
            _this.actions.aifPmsActions.startAifPmsTableLoader();
            _this.usecase.watchList.execute({
                onSuccess: function (data) {
                    var _a;
                    _this.actions.aifPmsActions.getAifPmsWatchList(data.data, false, data.totalpages);
                    if (data && ((_a = data.data) === null || _a === void 0 ? void 0 : _a.length) == 0) {
                        _this.actions.aifPmsActions.updateMsg({
                            msg: EmptyValidation.default,
                            show: true,
                            icon: "",
                        });
                    }
                    resolve(data);
                    _this.actions.aifPmsActions.stopAifPmsTableLoader();
                },
                onError: function (error) {
                    _this.actions.aifPmsActions.setError({
                        isOpen: true,
                        error: error,
                    });
                    _this.actions.aifPmsActions.stopAifPmsTableLoader();
                    reject(error);
                },
            }, _request);
        });
    };
    AifPmsPresenter.prototype.getValidateFormNumber = function (form_no) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateFormNumber.execute({
                onSuccess: function (data) {
                    var _a;
                    if (data && ((_a = data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        _this.actions.aifPmsActions.getValidateFormNumber(data.data);
                    }
                },
                onError: function (error) {
                    _this.actions.aifPmsActions.setError({
                        isOpen: true,
                        error: error,
                    });
                },
            }, form_no);
        });
    };
    AifPmsPresenter.prototype.updateWatchListData = function (req) {
        this.actions.aifPmsActions.updateWatchListData(req);
    };
    AifPmsPresenter.prototype.bookmark = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.bookmark.execute({
                            onSuccess: function (data) {
                                if (data) {
                                    resolve(data);
                                }
                                resolve(data);
                            },
                            onError: function (error) {
                                _this.actions.aifPmsActions.setError({
                                    isOpen: true,
                                    error: error,
                                });
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    AifPmsPresenter.prototype.bookmarkWatchList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.bookmarkWatchlist.execute({
                onSuccess: function (data) {
                    if (data) {
                        _this.actions.aifPmsActions.bookmarkWatchlist(data);
                        resolve(data);
                    }
                },
                onError: function (error) {
                    _this.actions.aifPmsActions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    AifPmsPresenter.prototype.updateSubCategoryId = function (req) {
        this.actions.aifPmsActions.updateSubCategoryId(req);
    };
    AifPmsPresenter.prototype.updateSubCategoryPMSId = function (req) {
        this.actions.aifPmsActions.updateSubCategoryPmsId(req);
    };
    AifPmsPresenter.prototype.multiBookmark = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.multiBookmark.execute({
                onSuccess: function (data) {
                    _this.actions.aifPmsActions.multiBookmark(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.aifPmsActions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    AifPmsPresenter.prototype.updateTransactionId = function (req) {
        this.actions.aifPmsActions.updateTransactionId(req);
    };
    AifPmsPresenter.prototype.ordersData = function (req) {
        this.actions.aifPmsActions.ordersData(req);
    };
    AifPmsPresenter.prototype.commonBankMaster = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.commonBankMaster.execute({
                onSuccess: function (data) {
                    _this.actions.aifPmsActions.commonBankMaster(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.aifPmsActions.commonBankMaster(null);
                    reject(error);
                },
            }, req);
        });
    };
    return AifPmsPresenter;
}());
export default AifPmsPresenter;
